import { CustomLink } from "./Link.styles";

const Link = ({ ...rest }) => <CustomLink {...rest}></CustomLink>;

export { Link };
